function escapeHTML(value: unknown) {
  return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character] || character)
}

export function safeAnnouncementHref(value: unknown) {
  const href = String(value || '').trim()
  if (href.startsWith('/') && !href.startsWith('//')) return href
  try {
    const parsed = new URL(href)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : ''
  } catch {
    return ''
  }
}

function renderInlineText(value: unknown) {
  return escapeHTML(value)
    .replace(/`([^`\n]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    .replace(/~~([^~\n]+)~~/g, '<del>$1</del>')
    .replace(/\*([^*\n]+)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br>')
}

export function renderAnnouncementMarkdown(content: unknown, linksFocusable = true) {
  const value = String(content || '')
  const linkPattern = /\[([^\]\n]+)\]\(([^)\s]+)\)/g
  let output = ''
  let cursor = 0
  for (const match of value.matchAll(linkPattern)) {
    output += renderInlineText(value.slice(cursor, match.index))
    const href = safeAnnouncementHref(match[2])
    if (!href) output += renderInlineText(match[1])
    else {
      const external = /^https?:\/\//i.test(href)
      output += `<a href="${escapeHTML(href)}"${external ? ' target="_blank" rel="noopener noreferrer"' : ''}${linksFocusable ? '' : ' tabindex="-1"'}>${renderInlineText(match[1])}</a>`
    }
    cursor = Number(match.index) + match[0].length
  }
  return output + renderInlineText(value.slice(cursor))
}
